import React, { useState, useEffect } from "react";
import "./FundraiserStatsTable.css";
import {
  RepresentativeDashboardTableStats,
  Fundraiser,
} from "../../../Interfaces/Dashboards";
import EditDivisionButton from "../NavigateToDivisionCreationButton";
import EditParticipantsButton from "../NavigateToEditParticipants";

interface FundraiserStatsTableProps {
  repFundraisers: Fundraiser[] | null;
}

const FundraiserStatsTable: React.FC<FundraiserStatsTableProps> = ({
  repFundraisers,
}) => {
  const [tab, setTab] = useState<string>("All");
  const [fundraisers, setFundraisers] = useState<Fundraiser[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async (status: string) => {
    setLoading(true);
    try {
      // Filter data based on status
      const filteredData = repFundraisers?.filter((fundraiser: Fundraiser) => {
        if (status === "All") return true;
        if (status === "Active") {
          return new Date(fundraiser.end_date) > new Date();
        }
        if (status === "Complete") {
          return new Date(fundraiser.end_date) <= new Date();
        }
        return false;
      });

      setFundraisers(filteredData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Watch for tab changes and fetch data
  useEffect(() => {
    fetchData(tab);
  }, [tab]);

  return (
    <div className="fundraiser-rep-dashboard-fundraiser-table">
      <div className="fundraiser-rep-dashboard-fundraiser-table-tabs">
        {["All", "Active", "Complete"].map((status) => (
          <button
            key={status}
            className={`fundraiser-rep-dashboard-fundraiser-table-tab ${
              tab === status ? "active" : ""
            }`}
            onClick={() => setTab(status)}
          >
            {status}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="fundraiser-rep-dashboard-fundraiser-table-loading">
          Loading...
        </div>
      ) : (
        <table className="fundraiser-rep-dashboard-fundraiser-table-table">
          <thead>
            <tr>
              <th>Fundraiser Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Fundraiser Code</th>
              <th>Total Billed</th>
              <th>Fundraiser Profit</th>
              <th>Fundraiser Sales</th>
              <th>Rep Commission</th>
              <th>Edit Divisions</th>
              <th>Edit Participants</th>
            </tr>
          </thead>
          <tbody>
            {fundraisers.length > 0 ? (
              fundraisers.map((fundraiser) => (
                <tr
                  key={`${fundraiser.organization_id}-${fundraiser.fundraiser_name}`}
                >
                  <td>{`${fundraiser.organization_name} - ${fundraiser.fundraiser_name}`}</td>
                  <td>{fundraiser.start_date}</td>
                  <td>{fundraiser.end_date}</td>
                  <td>{fundraiser.fundraiser_code}</td>
                  <td>${fundraiser.total_billed.toFixed(2)}</td>
                  <td>${fundraiser.fundraiser_profit.toFixed(2)}</td>
                  <td>
                    $
                    {(
                      fundraiser.fundraiser_profit + fundraiser.total_billed
                    ).toFixed(2)}
                  </td>
                  <td>${fundraiser.rep_commission.toFixed(2)}</td>
                  <td>
                    <EditDivisionButton
                      fundraiserID={fundraiser.fundraiser_id}
                    />
                  </td>
                  <td>
                    <EditParticipantsButton
                      fundraiserID={fundraiser.fundraiser_id}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6}>No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FundraiserStatsTable;
